<div class="acesso-shell">
  <!-- HERO PANEL (≥ md) — toda a seção é a imagem (texto integrado) -->
  <aside class="acesso-hero">
    <picture>
      <source [srcset]="heroImageUrlWebp" type="image/webp" />
      <img
        class="acesso-hero__image"
        [src]="heroImageUrl"
        alt="SmartApp — A plataforma completa para investir em imóveis. Calculadora, kanban, gestão financeira, SmartMatch e FlipLink em um só lugar."
        loading="eager"
        decoding="async"
      />
    </picture>
  </aside>

  <!-- FORM PANEL -->
  <main class="acesso-form">
    <div class="acesso-form__top">
      <a class="acesso-form__brand-mobile" [href]="portalUrl" rel="noopener">
        <img src="/assets/logos/smart-app-logo.webp" alt="SmartApp" width="124" height="24" class="h-6 w-auto" />
      </a>
    </div>

    <div class="acesso-form__card">
      @if (activeTab !== 'forgot') {
        <div
          class="acesso-tabs"
          role="tablist"
          aria-label="Login ou criação de conta"
        >
          <button
            type="button"
            role="tab"
            class="acesso-tabs__tab"
            [class.is-active]="activeTab === 'login'"
            [attr.aria-selected]="activeTab === 'login'"
            [attr.tabindex]="activeTab === 'login' ? 0 : -1"
            (click)="selectTab('login')"
          >
            Entrar
          </button>
          <button
            type="button"
            role="tab"
            class="acesso-tabs__tab"
            [class.is-active]="activeTab === 'register'"
            [attr.aria-selected]="activeTab === 'register'"
            [attr.tabindex]="activeTab === 'register' ? 0 : -1"
            (click)="selectTab('register')"
          >
            Criar conta
          </button>
        </div>
      }

      <div class="acesso-form__content" [attr.aria-live]="'polite'">
        @if (activeTab === 'login') {
          <app-login></app-login>
        } @else if (activeTab === 'register') {
          <app-register></app-register>
        } @else {
          <app-forgot-my-password></app-forgot-my-password>
        }
      </div>
    </div>
  </main>
</div>
